import { BootFatalError, type BootContext, type BootStep } from "./types.js";

export async function runPipeline(steps: BootStep[], ctx: BootContext): Promise<void> {
  const t0 = Date.now();
  const timings: string[] = [];
  for (const step of steps) {
    const s0 = Date.now();
    try {
      await step.run(ctx);
    } catch (err) {
      const msg = err instanceof Error ? err.message : String(err);
      if (step.critical) {
        ctx.log.error(`[boot] FATAL step=${step.name}: ${msg}`);
        throw err instanceof BootFatalError
          ? err
          : new BootFatalError(step.name, msg, { cause: err });
      }
      ctx.log.warn(`[boot] WARN step=${step.name} degraded: ${msg}`);
    }
    const ms = Date.now() - s0;
    timings.push(`${step.name}:${ms}`);
    ctx.log.info(`[boot] step=${step.name} ms=${ms}`);
  }
  ctx.log.info(
    `[boot] timeline role=${ctx.role} total=${Date.now() - t0} steps=${timings.join(",")}`,
  );
}
